import Enum from "./Enum";

export default Enum.create( {
	REGULAR_WEEKLY: "REGULAR_WEEKLY",
	SOLVE_PROBLEMS: "SOLVE_PROBLEMS",
	RESOLVE_CONFLICTS: "RESOLVE_CONFLICTS",
	GET_FEEDBACK: "GET_FEEDBACK",
	GIVE_FEEDBACK: "GIVE_FEEDBACK",
	REVIEW_PERFORMANCE: "REVIEW_PERFORMANCE",
	SET_GOALS: "SET_GOALS",
	PROGRESS_CHECK_IN: "PROGRESS_CHECK_IN",
	RECOGNIZE_AND_APPRECIATE: "RECOGNIZE_AND_APPRECIATE",
	ROLE_ALIGNMENT: "ROLE_ALIGNMENT",
	ENGAGEMENT_CHECK_IN: "ENGAGEMENT_CHECK_IN",
	HYBRID_WORK_CHECK_IN: "HYBRID_WORK_CHECK_IN",
	REMOTE_WORK_CHECK_IN: "REMOTE_WORK_CHECK_IN",
	PROFESSIONAL_DEVELOPMENT: "PROFESSIONAL_DEVELOPMENT",
	SKIP_LEVEL_MEETING: "SKIP_LEVEL_MEETING",
	FIRST_ONE_ON_ONE: "FIRST_ONE_ON_ONE",
	QUARTERLY_PERFORMANCE_REVIEW: "QUARTERLY_PERFORMANCE_REVIEW",
	ANNUAL_PERFORMANCE_REVIEW: "ANNUAL_PERFORMANCE_REVIEW",
	EMPLOYEE_ONBOARDING_30_60_90: "EMPLOYEE_ONBOARDING_30_60_90",
} );
